module.exports = __webpack_public_path__ + "static/media/crop_persona.cb61bce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Design/img/crop_persona.png
// module id = 270
// module chunks = 0